import store from '@/store/index'
import {
  MUTATE_SET_SHOW_OVERLAY,
  MUTATE_SET_TRANSITION_MAIN,
  MUTATE_SET_TRANSITION_OVERLAY,
  ACTION_SET_TRANSITION_MAIN_ASYNC
} from '@/store/types'

export default (newRoute, old) => {
  const resultNew = newRoute.meta.isOverlay;
  const resultOld = old && old.meta.isOverlay;

  if (!resultOld && resultNew) {
    store.commit(MUTATE_SET_SHOW_OVERLAY, true);
  } else if (!resultNew && resultOld) {
    // disable transition on main nav so it won't look iffy
    store.commit(MUTATE_SET_TRANSITION_OVERLAY, 'smd-transition-overlay');
    store.commit(MUTATE_SET_TRANSITION_MAIN, '');

    // delay hide overlay because its animating out
    store.dispatch(ACTION_SET_TRANSITION_MAIN_ASYNC, {
      value: 'smd-transition-panes',
      duration: 250
    });
  }
}
